import gql from 'graphql-tag';

export default gql`
  query Viewer {
    viewer {
      user {
        _id
        name
        email
        picture
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/data/queries/Viewer.js